<template>
  <div class="container ">
    <el-breadcrumb
      separator="/"
      style="padding-bottom: 16px; font-size: 20px; padding: 15px;"
    >
      <el-breadcrumb-item v-for="path in paths">
        <a @click="backToFolder(path)"><i :class="path.icon" /> {{ path.folder_name }}</a>

      </el-breadcrumb-item>
    </el-breadcrumb>
    <div class="card">
      <div class="card-body">
        <div class="flex align-items-center justify-content-end">
          <p class="h3 text-success fw-bold  float-end">
            <b-button
              id="toggle-btn"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-modal.modal-prevent-closing
              class="float-end"
              variant="outline-primary"
              @click="idfolderAtual();"
            >
              <feather-icon icon="FolderPlusIcon" />
              Criar Pastas
            </b-button>
          </p>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-prevent-closing"
      ref="my-modal"
      title="Nova pasta"
      ok-title="Criar Pasta"
      cancel-title="Cancelar"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form
        ref="form"
        @submit.stop.prevent="CriarPasta"
      >
        <b-form-group
          :state="nameState"
          label="Nome da pasta"
          label-for="name-input"
          invalid-feedback="Esse campo é obrigatório"
        >
          <b-form-input
            id="name-input"
            v-model="pastaAws.folder_name"
            :state="nameState"
            placeholder="Digite o nome da pasta"
            required
          />
        </b-form-group>
      </form>
    </b-modal>
    <ul
      v-for="item of folders"
      :key="item.id"
      class="players___26VY9 hvr-glow "
    >
      <li
        class="player-card___2Fvfg"
        draggable="true"
        style="opacity: 1;"
        @click="getFolder(item)"
      >
        <!--        <button @click.stop class="player-card&#45;&#45;checkbox___27L9W">-->
        <!--          <label class="ant-checkbox-wrapper content&#45;&#45;zindex">-->
        <!--            <span class="ant-checkbox">-->
        <!--              <input type="checkbox" class="ant-checkbox-input" value="" id="check1"-->
        <!--                name="check1"   @change="handleChecked(item)" v-model="item.is_selected" :true-value="true" :false-value="false">-->
        <!--            </span>-->
        <!--          </label>-->
        <!--        </button>-->
        <div
          class="ant-row ant-row-no-wrap ant-row-middle player-card--content___D1qZG"
          style="row-gap: 0px;"
        >
          <div
            class="ant-col player-card--thumb___35WZM"
            style="flex: 1 1 auto; min-width: 0px;"
          >
            <div class="player-card-thumb-name___2WjVQ">
              <div class="folder-thumb-name--folder___3VtKS">
                <span
                  role="img"
                  aria-label="folder"
                  class="anticon anticon-folder"
                >
                  <folder />
                </span>
              </div>
              <div class="player-card-thumb-name--info___21UGr">
                <div class="player-card-name___2r4hW">
                  <strong :id="'strong' + item.id">{{ item.folder_name }}</strong>

                  <input
                    :id="'input' + item.id"
                    v-model="item.folder_name"
                    style="width: 250px"
                    class="border border-1"
                    hidden
                    @click.stop
                  >
                  <span
                    :id="'icone-editar' + item.id"
                    role="img"
                    aria-label="edit"
                    tabindex="-1"
                    class="anticon anticon-edit player-card-name--edit_icon___3cbkf"
                    @click.stop="aparecerEdição(item.id);"
                  >
                    <button
                      class="btn "
                      style=" border: none;"
                      @click="deleteFolder()"
                    >
                      <feather-icon icon="Edit3Icon" />
                    </button>
                  </span>
                  <span
                    :id="'botao-salvar' + item.id"
                    role="img"
                    hidden
                    @click.stop="salvarEdicão(item)"
                  >
                    <feather-icon
                      icon="CheckIcon"
                      color="green"
                    />
                  </span>
                </div>
                <div class="player-card-thumb-name--info_date___97-MJ"><span
                  class="ant-typography ant-typography-ellipsis ant-typography-single-line ant-typography-ellipsis-single-line"
                >{{
                  item.folder_date
                }}</span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="ant-col player-card--info___1ux6J "
            style="flex: 1 1 auto; min-width: 0px;"
          >
            <a
              class="player-card-views___sZ32Z"
              href="#"
            />
            <div
              class=" align-self-center"
              @click.stop
            >
              <el-dropdown>
                <el-button
                  style=" border: none;"
                  type="button"
                  class="is-plain"
                >
                  <i class="el-icon-more" />
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click="open(item)">
                    <feather-icon
                      icon="TrashIcon"
                      size="18"
                      stroke="red"
                      class="mr-50"
                      @click="open(item)"
                    />
                    <span @click="open(item)">Remover</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios'
import { useApi } from '@/composables/useApi'
// eslint-disable-next-line import/extensions
import { FolderService } from '@/services/Folder.js'
import { mapActions, mapState } from 'vuex'
// const apiAWS = useApiAWS()
import {
  BButton, BFormGroup, BFormInput, BModal, VBModal, BCardText, BListGroup, BListGroupItem, BAlert, BLink, BCard,
} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import Ripple from 'vue-ripple-directive'
import { codePrevent } from '@/views/App/Pastas/code copy'
import Folder from '@/assets/images/folder/folder.vue'
import crypto from 'crypto'

const api = useApi()

export default {
  components: {
    BCardCode,
    BButton,
    BFormGroup,
    BCardText,
    BFormInput,
    BListGroup,
    BListGroupItem,
    BModal,
    BAlert,
    BLink,
    BCard,
    Folder,
  },
  props: ['value'],
  computed: {
    ...mapState('Folders', ['folderAtual']),
    folders: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    getUserData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
  },
  name: 'Modal',
  directives: {
    'b-modal': VBModal,

    Ripple,
  },
  data() {
    return {
      input: '',
      loading: false,
      paths: [],
      outerVisible: false,
      VUE_APP_HOST_API_AWS_S3: process.env.VUE_APP_HOST_API_AWS_S3,
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND,
      contentWidth: this.$store.state.appConfig.layout.contentWidth,
      userData: JSON.parse(localStorage.getItem('userData')),
      errorMessage: null,
      codePrevent,
      pastaAws: {
        folder_name: '',
      },
      nameState: null,
      checkFile: false,
      IdPasta: '',
      folderATUAL: {},
    }
  },

  methods: {
    ...mapActions('Folders', ['getAllFolderUser']),
    // ...mapActions('Videos', ['listarVideos']),
    handleChecked(item) {
      this.$emit('selectVideoFolder', item)
    },

    async getFolder(item) {
      this.loading = true
      this.$store.commit('Folders/setCurrentFolderId', item.id)
      this.$store.commit('Folders/setfolderAtual', item)

      localStorage.setItem('folderATUAL', JSON.stringify(item))
      this.$emit('updateVideos', item)
      this.getAllFolderUser()
      this.getFoldersAll(item.id)
      this.IdPasta = item
      if (this.paths.length === 0) {
        this.paths.push({
          folder_name: 'Meus Videos',
          icon: 'fi fi-bs-video-camera',
          id: 0,
        })
      }
      const res = this.paths.find(f => f.id === item.id)
      if (res === undefined) {
        this.paths.push(item)
      }

      this.$store.commit('Folders/setIdMainParams', item.id)
      await this.$store.dispatch('Folders/getAllFolderUser')
        .finally(() => {
          this.loading = false
        })
    },

    async getFoldersAll(id_folder) {
      const params = {
        id_main: id_folder,
      }
      await api.get(`/folderUser/${this.getUserData.id}`, {
        params,
      })
        .then(resp => {
          const formData = resp.data
          formData.map(v => v.is_selected = false)
          this.folders = formData
        })
    },

    deleteFolder(folder) {
      try {
        this.loading = true
        FolderService.deleteFolder(folder.id).then(response => {
          if (response) {
            this.getFoldersAll(folder.id_main)
            // if (typeof this.folderATUAL.id === "undefined") {

            //   this.getFoldersAll(0)
            // } else {
            //   this.getFoldersAll(this.folderATUAL.id)
            // }
            // ;
          }
        })
      } catch (error) {
        this.errorMessage = error
        this.loading = false
      }
    },

    deletarPastaAWS(item) {
      const options = {
        method: 'DELETE',
        url: `${this.VUE_APP_HOST_API_AWS_S3}`,
        params: {
          key: item,
          delete: '',
        },
      }

      axios.request(options).then(response => {
      }).catch(error => {
        console.error(error)
      })
    },

    open(item) {
      console.log('PASTA A SER DELETADA', item)
      //  this.folderATUAL = item;
      this.$confirm('Você tem certeza que deseja deletar a pasta? Se sim, todos os dados e arquivos serão removidos.', 'Deletar Pasta', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'Deletar pasta',
      }).then(res => {
        if (res) {
          this.deletarPastaAWS(item.folder_key_name)
          this.deleteFolder(item)
        }

        this.$message({
          type: 'success',
          message: 'Deletado com sucesso',
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete cancelado',
        })
      })
    },

    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.name = valid
      return valid
    },
    resetModal() {
      this.pastaAws.folder_name = ''
      this.nameState = null
    },

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.CriarPasta()
    },
    async idfolderAtual() {
      const pastaAtual = JSON.parse(localStorage.getItem('folderATUAL'))
      console.log('PASTAATUAL', pastaAtual)
      this.folderATUAL = pastaAtual
    },
    handleSubmit() {
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/folder`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: `{"folder_name":"${this.pastaAws.folder_name.replace(/(\r\n|\n|\r)/gm, '')
        }","folder_backet_adress":"${this.Url_pasta
        }","id_main":"${this.folderATUAL.id
        }","folder_key_name":"${this.key_name
        }","id_user":"${this.userData.id}"}`,
      })
        .then(async response => {
          if (this.folderATUAL === 0) {
            this.getFoldersAll(0)
            await this.getAllMoverFolder({
              id_main: 0,
            }).then(res => {
              this.folders = res
              // seta todas as pastas na store
              // this.$store.commit('Folders/setAllFoldersMain', res)
            })
          } else {
            this.getFoldersAll(this.folderATUAL.id)
            await this.getAllMoverFolder({
              id_main: this.folderATUAL.id,
            }).then(res => {
              this.folders = res
              // seta todas as pastas na store
              // this.$store.commit('Folders/setAllFoldersMain', res)
            })
          }

          await this.$store.dispatch('Folders/getAllFolderUser')
            .finally(() => {
              this.loading = false
            })
          this.$notify({
            title: 'Success',
            message: 'Pasta criada com sucesso.',
            type: 'success',
          })
        })
        .catch(err => console.error(err))

      if (!this.checkFormValidity()) {
        return
      }
      this.folders.push(this.folder)
      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn')
      })
    },

    CriarPasta() {
      const crypto = require('crypto')
      const results = this.pastaAws.folder_name

      const hash = crypto.createHash('sha256')
        .update(results.toString())
        .digest('hex')

      const NameFoldeHash = hash.substring(0, 30)

      if (this.folderATUAL === 0) {
        this.caminhoPasta = `${this.userData.user_file_key}UploadFolderVideos/`
      } else {
        this.caminhoPasta = this.folderATUAL.folder_key_name
      }

      fetch(`${this.VUE_APP_HOST_API_AWS_S3}/create?caminho=${this.caminhoPasta}${NameFoldeHash}/`, {
        method: 'POST',
      })
        .then(res => res.json())
        .then(res => {
          this.Url_pasta = res.fileUrl
          this.key_name = res.file_key

          if (res.status == 201) {
            this.handleSubmit()
            if (res) {

              // this.getFoldersAll(this.IdPasta);
            }
          }
        })
        .catch(error => {
          this.$notify.error({
            title: 'Error',
            message: `Esta é uma mensagem de erro: ${error}`,
          })
        })
    },

    async cancelMoverFolder() {
      this.outerVisible = false
      this.paths = []
      this.loading = true
      this.$store.commit('Folders/setIdMainParams', 0)
      await this.$store.dispatch('Folders/getAllFolderUser')
        .finally(() => {
          this.loading = false
        })
    },
    async backToFolder(item) {
      if (item.id === 0) {
        localStorage.setItem('folderATUAL', JSON.stringify(item.id))
      } else {
        localStorage.setItem('folderATUAL', JSON.stringify(item))
      }
      this.loading = true
      const indexItem = this.paths.indexOf(item)
      this.$emit('updateVideos', item)
      this.paths.forEach((p, i) => {
        if (i > indexItem) {
          this.paths.splice(i, 1)
        }
      })
      if (item.id || item.id === 0) {
        // this.clearFolder()
      }

      this.getFoldersAll(item.id)
    },
    clearFolder() {
      this.$store.commit('Folders/setfolderAtual', {
        id: 0,
        folder_name: null,
        folder_backet_adress: null,
        id_main: null,
        id_user: null,
        folder_date: null,
        folder_key_name: null,
      })
    },
    aparecerEdição(item) {
      const strong = document.getElementById(`strong${item}`)
      const input = document.getElementById(`input${item}`)
      const botaosalvar = document.getElementById(`botao-salvar${item}`)
      const iconeeditar = document.getElementById(`icone-editar${item}`)
      strong.setAttribute('hidden', '')
      iconeeditar.setAttribute('hidden', '')
      botaosalvar.removeAttribute('hidden')
      input.removeAttribute('hidden')
    },
    salvarEdicão(item) {
      const options = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: `{"folder_name":"${item.folder_name}"}`,
      }

      fetch(`https://api-stage.vslbooster.com/updateNameFolder/${item.id}`, options)
        .then(response => response.json())
        .then(response => {
          const strong = document.getElementById(`strong${item.id}`)
          const input = document.getElementById(`input${item.id}`)
          const botaosalvar = document.getElementById(`botao-salvar${item.id}`)
          const iconeeditar = document.getElementById(`icone-editar${item.id}`)
          input.setAttribute('hidden', '')
          botaosalvar.setAttribute('hidden', '')
          iconeeditar.removeAttribute('hidden')
          strong.removeAttribute('hidden')
          this.$message({
            type: 'success',
            message: 'Salvo com sucesso',
          })
        })
        .catch(err => console.error(err))
    },
  },
}
</script>
<style lang="scss" scoped>

@import '@/assets/scss/card_videos/CardVideos.scss';

.player-card-thumb-name___2WjVQ .folder-thumb-name--folder___3VtKS {
    min-width: 8rem;
    text-align: center;
}
.anticon {
    display: inline-block;
    color: inherit;
    font-style: normal;
    line-height: 0;
    text-align: center;
    text-transform: none;
    vertical-align: -.125em;
    text-rendering: optimizelegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
</style>
